export type { Member } from './entities/members';
export {
  DocGrantedUsersService,
  type GrantedUser,
} from './services/doc-granted-users';
export { GuardService } from './services/guard';
export { MemberSearchService } from './services/member-search';
export { WorkspaceMembersService } from './services/members';
export {
  ObjectPermissionMutationService,
  type PendingObjectPermissionAssignments,
} from './services/object-permission-mutation';
export { WorkspacePermissionService } from './services/permission';
export { MemberSearchSession } from './session/member-search-session';
export {
  type DocPermissionActions,
  type WorkspacePermissionActions,
} from './stores/guard';
export { PermissionSnapshotStore } from './stores/permission-snapshot';

import { type Framework } from '@toeverything/infra';

import { WorkspaceServerService } from '../cloud';
import { DocMutationService, DocScope, DocService } from '../doc';
import { FolderApiService } from '../folder-api/services/folder-api';
import { OfflineMutationOutboxService } from '../offline-mutation-outbox';
import { AccessibleFolderCacheStore } from '../organize/stores/accessible-folder-cache';
import { GlobalState } from '../storage';
import {
  WorkspaceLocalState,
  WorkspaceScope,
  WorkspaceService,
  WorkspacesService,
} from '../workspace';
import { WorkspaceMembers } from './entities/members';
import { WorkspacePermission } from './entities/permission';
import { DocGrantedUsersService } from './services/doc-granted-users';
import { GuardService } from './services/guard';
import { MemberSearchService } from './services/member-search';
import { WorkspaceMembersService } from './services/members';
import { ObjectPermissionMutationService } from './services/object-permission-mutation';
import { WorkspacePermissionService } from './services/permission';
import { DocGrantedUsersStore } from './stores/doc-granted-users';
import { GuardStore } from './stores/guard';
import { MemberSearchStore } from './stores/member-search';
import { WorkspaceMembersStore } from './stores/members';
import { WorkspacePermissionStore } from './stores/permission';
import { PermissionSnapshotStore } from './stores/permission-snapshot';

export function configurePermissionsModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(WorkspacePermissionService, [
      WorkspaceService,
      WorkspacesService,
      WorkspacePermissionStore,
    ])
    .store(WorkspacePermissionStore, [
      WorkspaceServerService,
      WorkspaceLocalState,
      GlobalState,
    ])
    .entity(WorkspacePermission, [WorkspaceService, WorkspacePermissionStore])
    .service(WorkspaceMembersService, [WorkspaceMembersStore, WorkspaceService])
    .store(WorkspaceMembersStore, [WorkspaceServerService])
    .entity(WorkspaceMembers, [WorkspaceMembersStore, WorkspaceService])
    .service(MemberSearchService, [MemberSearchStore, WorkspaceService])
    .store(MemberSearchStore, [WorkspaceServerService])
    .service(ObjectPermissionMutationService, [
      WorkspaceService,
      OfflineMutationOutboxService,
      FolderApiService,
      DocMutationService,
      AccessibleFolderCacheStore,
    ])
    .service(GuardService, [
      GuardStore,
      WorkspaceService,
      WorkspacePermissionService,
    ])
    .store(GuardStore, [
      WorkspaceService,
      WorkspaceServerService,
      PermissionSnapshotStore,
    ])
    .store(PermissionSnapshotStore, [
      WorkspaceServerService,
      WorkspaceService,
      GlobalState,
    ]);

  framework
    .scope(WorkspaceScope)
    .scope(DocScope)
    .service(DocGrantedUsersService, [
      DocGrantedUsersStore,
      WorkspaceService,
      DocService,
      ObjectPermissionMutationService,
    ])
    .store(DocGrantedUsersStore, [WorkspaceServerService]);
}
